module.exports = __webpack_public_path__ + "static/media/expanded.7ffd71ad.svg";